import { render } from "./linkredirect.vue?vue&type=template&id=74916aba&scoped=true"
import script from "./linkredirect.vue?vue&type=script&lang=js"
export * from "./linkredirect.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-74916aba"

export default script